import { Box, CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import DashboardDisplay from '~/components/widgets2/dashboard/DashboardDisplay'
import useHomeDashboard from '~/hooks/useHomeDashboard'
import defaultHomePage from '~/lib/defaultHomePage'
import { navigationCreators } from '../actions/creators'
import Dashboard from '../components/widgets2/dashboard/Dashboard'
import { routePaths } from '../lib/routes'
import { authSelectors } from '../selectors'

export default function HomePageManageView() {
    const isPowerUser = useSelector(authSelectors.getIsPowerUser)
    const { dashboard, isLoading, isError } = useHomeDashboard()
    const dispatch = useDispatch()

    if (!isPowerUser) {
        dispatch(navigationCreators.goTo(routePaths.HOME))
        return
    }

    if (isError) return <div> Oops... Something went wrong </div>

    if (isLoading)
        return (
            <Box sx={{ display: 'flex' }}>
                <CircularProgress />
            </Box>
        )

    if (dashboard) return <Dashboard id={dashboard.id} />

    return <DashboardDisplay config={defaultHomePage} widgets={[]} />
}
